// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

class Dot extends Component {
  render() {
    const {
      color = colors.green,
      label,
      active,
      selectable,
      size = 24,
      fontSize = 12,
      onSelect,
      margin = '0 8px'
    } = this.props

    const classes = StyleSheet.create({
      dot: {
        height: size,
        width: size,
        fontSize,
        paddingTop: Math.floor(size / 5),
        color: 'white',
        margin,
        textAlign: 'center',
        backgroundColor: active ? color : colors.grey,
        borderRadius: '50%',
        display: 'inline-block'
      },
      selectable: {
        ':hover': {
          cursor: 'pointer'
        }
      }
    })

    return (
      <div
        onClick={() => onSelect && onSelect()}
        className={css(classes.dot, selectable && classes.selectable)}
      >
        {label}
      </div>
    )
  }
}

Dot.propTypes = {
  color: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  active: PropTypes.bool,
  selectable: PropTypes.bool,
  size: PropTypes.number
}

export default Dot
